$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // ========================
  // DROPDOWN SCRIPTS 
  // ========================
  const dropdownContainer = $('.mobile-menu-container');

  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search Website');
  $('.searchBoxInput input').val('');
  $(dropdownContainer).find('.search-container').attr('placeholder', 'Search Website');
  $('#mobileSearchInput').val('');
  $('.header .emailSignup .emailInputSubmit .button').text('');

  // Dropdown script for ticket button and containers
  $('.mobile-menu-footer-links').empty();
  $(dropdownContainer).append('<div class="dropdown-wrap"></div>');
  $(dropdownContainer).find('.search-container').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-slider').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-footer-links').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-header').append('<div class="inner-container"></div>');
  $('.header .ticket-container').clone().appendTo('.mobile-menu-container .inner-container');
  $(dropdownContainer).find('.close-mobile-menu').appendTo('.mobile-menu-container .inner-container');

  // Mobile menu toggle
  $('.mobile-nav-toggle').append('<div></div><div></div><div></div>')
  $('.mobile-nav-toggle').on('click', () => {
    $(dropdownContainer).find('.mobile-menu-slider .m-group').each(function () {
      $(this).find('.next-level-btn').empty();
    })
    $('.mobile-menu-slider').css('height', 'auto')
  });


  // ========================
  // COUNTDOWN SCRIPTS 
  // ========================
  $(window).load(function () {
    setTimeout(() => {
      $('.count-container').css('opacity', 1);
      $('.count-container').css('transform', 'none');
    }, 900);
  })

  // ========================
  // EMAIL SIGNUP SCRIPTS 
  // ========================
  $('.tier-4-container .emailSignupText').after('<div class="signup-wrap"></div>');
  $('.tier-4-container .emailInputField').appendTo('.signup-wrap');
  $('.tier-4-container .emailInputSubmit').appendTo('.signup-wrap');
  $('.tier-4-container .emailInputSubmit a').text('Sign up');
  $('.tier-4-container .signup-wrap input').attr('placeholder', 'Enter Email...');
  $('.tier-4-container .signup-wrap input').val('');


  // ========================
  // MISC SCRIPTS 
  // ========================
  $(window).load(function () {
    $('.header .navMobileMenuShiftedGoBack').remove();
  })
});

// ========================
// Parallax effect
// ========================
$(document).ready(function () {
  $(window).on('scroll', function () {
    let $card = $('#eventCards .image-container');
    if ($card.length) {
      $(window).on('scroll', function () {
        let scrollPos = $(window).scrollTop();
        let cardOffset = $card.offset().top;
        let windowHeight = $(window).height();

        if (scrollPos + windowHeight > cardOffset) {
          let parallaxScroll = cardOffset - scrollPos - windowHeight;

          $('#eventCards .image-container').css({
            'transform': 'translateY(' + (parallaxScroll * 0.1) + 'px)'
          });
          $('#multiScheduleFeature .image-container').css({
            'transform': 'translateY(' + (parallaxScroll * 0.1) + 'px)'
          });
        }
      });
    }
  })
});

